<template>
    <div>
    <h2> Beast's Lair:</h2>
    Download Annotated Map:
    <a @click="$emit('downloadImg', 'Beasts Lair')">Download</a><br/>
    Download Clean Map:
    <a href="https://s3.amazonaws.com/files.d20.io/images/231255078/lljlq9qQ4XJkUV55bSqW2A/original.jpg?162493506255" target="_blank">Map</a><br/>
    The Beast's Lair is a final encounter. It is arena style, so monsters will spawn one after another.
    <v-row>
        <v-col>
            <img id="Beasts Lair" :src="require('../../../assets/Annotated_Beasts_Lair_Map.png')"  contain height="942px"/>
        </v-col>
        <v-col>
        <h4>Map Details: </h4>
        <ul>
            <li>This encounter takes place in a cave on the prime material plane.</li>
            <li>The center area is well lit, but players vision is reduced to 20 feet once inside poisonous gas.</li>
            <li>The ceiling in the center room is 60 feet, the caverns are 40 feet.</li>
            <li>Most of this dungeon is filled with poison gas, and after 1 hour of real time the main chamber becomes filled with poisonous gas. None of the monsters in the encounter are affected by the poison.</li>
            <li>Map is 50x50</li>
            <li><b>Color Code:</b></li>
            <ul>
                <li>Player Spawn: Pink</li>
                <li>Treasure: Gold</li>
                <li>Monster Spawns: Red</li>
                <li>Areas of interest: Green</li>
            </ul>
        </ul>
        <br/><br/>     

        <h4>Monsters:</h4>
        <ul>
            <li><b>Wave 1 CR 16: </b> </li>
            First wave appears the moment players enter arena. Each creature begins in a different area but all know the exact location of the players when they spawn. Players feel eyes on them as they enter but can't discern where from. They can hear from all directions the sounds of large creatures moving about.
            <ul>
                <li><b>1) Miasmic Hydra CR 13: </b> Spawns in area 1, double its movement speed</li>
                <li><b>2) Legendary Chimera CR 13:</b> Spawns Area 3, double its movement speed</li>
                <li><b>3) Grisantian Lion CR 14: </b> Spawns Area 4, double its movement speed</li>
            </ul>            
            <br/>
            <li><b>Wave 2 CR 18: </b> </li
            >Wave 2 begins 2 rounds after all monsters from wave 1 are slain. Thessalhydra falls from the ceiling in the center of the room. Roof becomes 20 feet higher. All player within AoI1 take 10d6 points of bludgeoning damage as rocks fall from the roof and are knocked prone, however they can make a reflex check dc 26 to reduce it by half and avoid being knocked prone. Any players that fail the check must make a fortitude save dc 30 or be stunned for 1 round.
            <ul>
                <li><b>1) Thessalhydra CR 18: </b> Thessalhydra's hit points become 570, it gains 8 mythic points, and the following abilities:
                <ul>
                    <li><b>Mythic Status Resistance: </b> for 1 mythic point, when thessalhydra is affected by any negative status it wants to ignore it can spend a mythic point to completely negate it, this is not an action and can be done whenever it so chooses. This can negate any negative status, even grappling (but not death)</li>
                    <li><b>Death Throes: </b> when thessalhydra is reduced below 0 hit points it can spend a mythic point to make an attack against any target within range, if it hits and deals damage the thessalhydra gains hit points equal to the damage dealt. It can use this ability as often as it wants, and even multiple times as long as it is below 0 hit points. </li>
                    <li><b>Mythic Breath Weapon: </b> The thessalhydra can spend 3 mythic points to use its breath weapon as a swift action, when it does it can choose to make it a 60 ft cone or a 120 ft line. It can use this ability whether its breath weapon is recharged or not, and using it does not set its breath weapon on cool down.</li>
                </ul>
                </li>
            </ul>
            <br/>           
        </ul>
        <br/><br/>   
                
        </v-col>
    </v-row>
    

        <h4>Treasure:</h4>
        <ul>
            <li><b>1) E+ Armor Enchantment 100</b></li>
            <li><b>2) Resurrective 100</b></li>
            <li><b>3) E+ Stats 50</b></li>
            <li><b>4) E+ Weapon Enchantment 100</b></li>
            <li><b>5) Level Up 200</b></li>
            <li><b>6) Typed Spell/Maneuver 20</b></li>
            <li><b>7) Roll x2 Feat 175 </b></li>
            <li><b>8) 4-8 Potions 50</b></li>
            <li><b>9) Rare Typed Perk 125: </b> Note: this means player can choose from a fighter perk, gambit, Ki Perk, Rogue Talent, or Rage Power</li>
            <li><b>10) 6-12 Potions 50</b></li>
            <li><b>11) U Weapon Enchantment 200</b></li>
            <li><b>12) Typed Spell/Maneuver 40</b></li>
            <li><b>13) Lvl++ Spell/Maneuver 40</b></li>
            <li><b>14) Typed Feat 75</b></li>
            <li><b>15) E+ Armor Enchantment 100</b></li>
            <li><b>16) Resurrective 100</b></li>
            <li><b>17) E+ Perk 125</b></li>
            <li><b>18) Teamwork Feat 175</b></li>
            <li><b>19) E+ Perk 125</b></li>
        </ul>
        <br/><br/>
        <h4>Areas of Interest: </h4>
        <ul>
            <li><b>1) Poisonous Zone: </b> If a player ends their turn outside of the highlighted green ring (or the center area after 1 hour passes) they must make a fortitude save DC 14 or receive 1d4 points of constitution damage. Each round they make this save the DC increases by 1. This DC does not go back to 14 even if they player leaves the poisonous area and re-enters it. While inside the toxic gas their vision reduces to 20 feet. Once an hour passes and the main chamber fills with gas the DC increases by 3 each time a player needs to make the save.</li>
            
        </ul>
        <br/><br/>
    </div>
</template>
            
<script>
import {
VRow,
VCol,
} from "vuetify/lib";
export default {
  components: {    
    VRow,
    VCol,
  },
  data(){
    return{
        
    }
  },
  methods:{

  }
}
</script>